<template>
  <ShortcutPage :release="release"></ShortcutPage>
</template>
<script>
import ShortcutPage from './ShortcutPage'

export default {
  name: 'Celeritas',
  data: function() {
    return { release: null }
  },
  components: {
    ShortcutPage,
  },
  mounted: function () {
    this.release = {
      img: '/img/album-constellations.jpeg',
      name: 'Constellation',
      type: 'album',
      links: [
        {
          service: 'bandcamp',
          url: 'https://grizzlycogs.bandcamp.com/album/constellations',
          btnLabel: 'Listen'
        },
        {
          service: 'spotify',
          url: 'https://open.spotify.com/intl-fr/album/5b2TspCz0ISai65BYxR0mN?si=aH_zwHGDR56iUjstLPL4dg',
          btnLabel: 'Listen'
        },
        {
          service: 'deezer',
          url: 'https://link.deezer.com/s/32z6zGqwlSfguurtbm0MT',
          btnLabel: 'Listen'
        },
        {
          service: 'apple',
          url: 'https://music.apple.com/fr/album/constellations/1880282800',
          btnLabel: 'Listen'
        },
        {
          service: 'amazon',
          url: 'https://amazon.fr/music/player/albums/B0GPNDW3KK?marketplaceId=A13V1IB3VIYZZH&musicTerritory=FR&ref=dm_sh_AlnBfAfs0nLaBZjGVfZXZo6vK',
          btnLabel: 'Buy'
        },
        {
          service: 'tidal',
          url: 'https://tidal.com/album/501165481',
          btnLabel: 'Listen'
        }
      ]
    }
  }
}
</script>